
import {ref, toRefs, watchEffect} from "vue";
import {EventDetailType, OfferDetailType, RewardDetailType} from "@/store/store.event.type";
import SvgIcon from "@/components/common/SvgIcon.vue";
import router from "@/router";
import MemberHeader from "@/components/member/MemberHeader.vue";
import {getDetail, getMemberClubByType} from "@/utils/general";
import store from "@/store";
import i18n from "@/locales";

export default {
  name: "RewardDetail",
  displayName: "Details",
  components: {MemberHeader, SvgIcon},
  props: {
    category: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true,
    }
  },
  setup(props: any) {
    const {category, id} = toRefs(props);
    const detail = ref<RewardDetailType | OfferDetailType | EventDetailType>();
    watchEffect(() => {
      const cat = category.value.toLowerCase();
      const type = store.state.selectedType;
      const memberClub = getMemberClubByType(type);
      const memberNo = store.state.memberData[type]?.ProfileDetails?.MemberNo;
      const sessionKey = store.state.memberData[type]?.SessionKey;
      getDetail<RewardDetailType | OfferDetailType | EventDetailType>(
          cat, id.value, memberClub, memberNo, sessionKey
      ).then((res: RewardDetailType | OfferDetailType | EventDetailType) => {
        console.log(res);
        detail.value = res;
      }
    )
      // if (cat === "reward") {
      // } else {
      //   detail.value = sampleOfferDetails;
      // }
      console.log(id.value);
    });

    const onBackClicked = () => {
      if (category.value === "event") {
        router.push({
          name: "Member",
        });
      } else {
        router.push({
          name: "List",
          params: {
            category: category.value,
            lang: i18n.global.locale
          }
        });
      }

    }

    return {
      detail,
      onBackClicked,
    }
  }

}
